import React from 'react';
import { Box, Icon, Tooltip } from '@mui/material';
import { PageStyled } from './index.styles';
import { GSvgIcon } from 'components/svg-icon';
import { t } from 'i18next';

interface DataProps {
    data: any;
    maxSize?: number;
}

const HotelExpeditionInformation = ({ data = [], maxSize = 0 }: DataProps) => {
    // Full list mock data
    // data = [
    //     'HasFreeTransfer',
    //     'HasWiFi',
    //     'HasParking',
    //     'IsIsolated',
    //     'HasFreeCancel',
    //     'NoPrePayment',
    //     'HasInstallment',
    //     'HasNoCard',
    //     'IsBreakfastIncluded',
    //     'IsHalfBoard',
    //     'IsFullBoard',
    //     'IsAllInclusive',
    // ];

    const typeOfVehicleData = [
        {
            name: 'HasFreeTransfer',
            label: t('hotel.widgets.hotelExpeditionInformation.HasFreeTransfer'),
            icon: <Icon>transfer_within_a_station</Icon>,
            order: 1,
        },
        {
            name: 'HasWiFi',
            label: t('hotel.widgets.hotelExpeditionInformation.HasWiFi'),
            icon: <Icon>wifi</Icon>,
            order: 2,
        },
        {
            name: 'HasParking',
            label: t('hotel.widgets.hotelExpeditionInformation.HasParking'),
            icon: <Icon>local_parking</Icon>,
            order: 3,
        },
        {
            name: 'IsIsolated',
            label: t('hotel.widgets.hotelExpeditionInformation.IsIsolated'),
            icon: <GSvgIcon name="is_isolated" size={24} />,
            order: 4,
        },
        {
            name: 'HasFreeCancel',
            label: t('hotel.widgets.hotelExpeditionInformation.HasFreeCancel'),
            icon: <Icon>published_with_changes</Icon>,
            order: 5,
        },
        {
            name: 'NoPrePayment',
            label: t('hotel.widgets.hotelExpeditionInformation.NoPrePayment'),
            icon: <Icon>payment</Icon>,
            order: 6,
        },
        {
            name: 'HasInstallment',
            label: t('hotel.widgets.hotelExpeditionInformation.HasInstallment'),
            icon: <Icon>payments</Icon>,
            order: 7,
        },
        {
            name: 'HasNoCard',
            label: t('hotel.widgets.hotelExpeditionInformation.HasNoCard'),
            icon: <Icon>credit_card_off</Icon>,
            order: 8,
        },
        {
            name: 'IsBreakfastIncluded',
            label: t('hotel.widgets.hotelExpeditionInformation.IsBreakfastIncluded'),
            icon: <Icon>breakfast_dining</Icon>,
            order: 9,
        },
        {
            name: 'IsHalfBoard',
            label: t('hotel.widgets.hotelExpeditionInformation.IsHalfBoard'),
            icon: <Icon>free_breakfast</Icon>,
            order: 10,
        },
        {
            name: 'IsFullBoard',
            label: t('hotel.widgets.hotelExpeditionInformation.IsFullBoard'),
            icon: <Icon>restaurant</Icon>,
            order: 11,
        },
        {
            name: 'IsAllInclusive',
            label: t('hotel.widgets.hotelExpeditionInformation.IsAllInclusive'),
            icon: <GSvgIcon name="all_inclusive" size={24} />,
            order: 12,
        },
    ];

    const list = typeOfVehicleData
        .filter((item: any) => (data.some((el: any) => el === item.name) === true ? item : undefined))
        .sort((a: any, b: any) => a.order - b.order);

    return (
        <PageStyled>
            {list.length > 0 && (
                <div className="expedition-information">
                    {list.map((item: any, index: number) => {
                        return (maxSize === 0 ? true : index < maxSize) ? (
                            <Tooltip
                                key={index}
                                placement="top"
                                arrow
                                componentsProps={{
                                    tooltip: {
                                        className: 'primary',
                                    },
                                }}
                                children={<div className="icon-box">{item.icon}</div>}
                                title={item.label}
                            />
                        ) : (
                            ''
                        );
                    })}

                    {list.length > maxSize && maxSize !== 0 && (
                        <Tooltip
                            placement="top"
                            arrow
                            componentsProps={{
                                tooltip: {
                                    className: 'primary',
                                },
                            }}
                            children={
                                <div className="icon-box">
                                    <Icon>more_horiz</Icon>
                                </div>
                            }
                            title={list.map((item: any, index: number) => {
                                return index >= maxSize ? (
                                    <div key={index}>
                                        <Box display="flex" alignItems="center">
                                            <div style={{ transform: 'scale(0.7)' }}>{item.icon}</div>
                                            {item.label}
                                        </Box>
                                    </div>
                                ) : (
                                    ''
                                );
                            })}
                        />
                    )}
                </div>
            )}
        </PageStyled>
    );
};

export default HotelExpeditionInformation;
